/** Algunos navegadores sin servicio de push nunca resuelven `pushManager.subscribe`. */
const SUSCRIBIR_TIMEOUT_MS = 20_000;

/** La clave VAPID llega en base64url; `pushManager.subscribe` la necesita en bytes. */
export function claveVapidABytes(clave: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (clave.length % 4)) % 4);
  const base64 = (clave + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const bytes = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; i++) {
    bytes[i] = raw.charCodeAt(i);
  }
  return bytes;
}

/** Una suscripción hecha con otra clave VAPID no sirve: el back no puede firmarle avisos. */
function usaClave(suscripcion: PushSubscription, clave: Uint8Array): boolean {
  const actual = suscripcion.options.applicationServerKey;
  if (!actual) return false;
  const bytes = new Uint8Array(actual);
  return bytes.length === clave.length && bytes.every((byte, i) => byte === clave[i]);
}

/** Reusa la suscripción del navegador si es de esta clave; si no, crea una nueva. */
export async function suscribirConClave(
  registro: ServiceWorkerRegistration,
  clavePublica: string,
): Promise<PushSubscription> {
  const clave = claveVapidABytes(clavePublica);
  const existente = await registro.pushManager.getSubscription();
  if (existente && usaClave(existente, clave)) {
    return existente;
  }
  await existente?.unsubscribe();

  let timeout: ReturnType<typeof setTimeout> | undefined;
  return Promise.race([
    registro.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: clave }),
    new Promise<never>((_, reject) => {
      timeout = setTimeout(
        () => reject(new Error('El navegador no respondió a la suscripción')),
        SUSCRIBIR_TIMEOUT_MS,
      );
    }),
  ]).finally(() => clearTimeout(timeout));
}
